import { PropsWithChildren } from 'react';

import {
  StyledStickyDesktopWrapper,
  StyledStickyMobileWrapper,
  StyledSticky,
  StyledStickyContainer,
} from './styles';

export interface StickyColumnProps extends PropsWithChildren {
  stickyTopOffset?: number;
}

export default function StickyColumn(props: StickyColumnProps) {
  const { stickyTopOffset = 0, children } = props;

  return (
    <>
      <StyledStickyDesktopWrapper>
        <StyledSticky
          topOffset={-1 * stickyTopOffset}
          stickyTopOffset={stickyTopOffset}
        >
          <StyledStickyContainer stickyTopOffset={stickyTopOffset}>
            {children}
          </StyledStickyContainer>
        </StyledSticky>
      </StyledStickyDesktopWrapper>
      <StyledStickyMobileWrapper>{children}</StyledStickyMobileWrapper>
    </>
  );
}
